import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AssetSectionComponent } from '../asset-section/asset-section.component';
import { ClientSectionComponent } from '../client-section/client-section.component';
import { FinancingSectionComponent } from '../financing-section/financing-section.component';
import { PremisesSectionComponent } from '../premises-section/premises-section.component';

import { ComparativeComponent } from '../comparative/comparative.component';
import { Router } from '@angular/router';
import { Customer } from '../../shared/models/quotation-model/customer.model';
import { EventEmiterService } from '../../shared/services/quotation/event-emiter.service';
import { AnnualInsurance } from '../../shared/models/quotation-model/catalogs/annual-insurance.model';
import { Brand } from '../../shared/models/quotation-model/catalogs/brand.model';
import { Coverage } from '../../shared/models/quotation-model/catalogs/coverage.model';
import { DeadLine } from '../../shared/models/quotation-model/catalogs/dead-line.model';
import { Destination } from '../../shared/models/quotation-model/catalogs/destination.model';
import { InsurancePayment } from '../../shared/models/quotation-model/catalogs/insurance-payment.model';
import { PersonType } from '../../shared/models/quotation-model/catalogs/person-type.model';
import { PlanType } from '../../shared/models/quotation-model/catalogs/plan-type.model';
import { Plan } from '../../shared/models/quotation-model/catalogs/plan.model';
import { Program } from '../../shared/models/quotation-model/catalogs/program.model';
import { Model } from '../../shared/models/quotation-model/catalogs/quotation-model.model';
import { VehicleUse } from '../../shared/models/quotation-model/catalogs/vehicle-use.model.model';
import { QuotationComparative } from '../../shared/models/quotation-model/main/quotation-comparative.model';
import { QuotationCompareCoverages } from '../../shared/models/quotation-model/main/quotation-compare-coverages.model';
import { QuotationCompareDeadLines } from '../../shared/models/quotation-model/main/quotation-compare-deadlines.model';
import { QuotationEditFinalValues } from '../../shared/models/quotation-model/main/quotation-edit-final-values.model';
import { QuotationFinancialValues } from '../../shared/models/quotation-model/main/quotation-financial-values.model';
import { SelectQuotationOutData } from '../../shared/models/quotation-model/main/select-quotation-out-data.model.model';
import { StickyToolbarComponent } from '../sticky-toolbar/sticky-toolbar.component';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss'],

  imports: [
    ClientSectionComponent,
    AssetSectionComponent,
    FinancingSectionComponent,
    PremisesSectionComponent,
    StickyToolbarComponent,
    ComparativeComponent,
    MatIcon,
    MatButtonModule,
    CommonModule,
    MatTooltipModule,
  ],
})
export class QuotationComponent implements OnInit, AfterViewInit {
  @Input() initQuotationId!: number;
  @Input() initTicketId!: number | null;
  @Input() Page!: number;
  //Modo Edición
  hasQuotation!: boolean;
  //Indican la sección activa
  activeClient!: boolean;
  activeAsset!: boolean;
  activeFinancing!: boolean;
  activeFinancingData!: boolean;
  activeFinancialData!: boolean;
  //Indican la herramienta activa
  activeToolBar!: boolean;
  activeQuotationPDF!: boolean;
  activateComparative!: boolean;
  //Datos summary
  customer: Customer = {} as Customer;
  selectedPersonType = {} as PersonType;
  selectedDestination = {} as Destination;
  modelSelected = {} as Model;
  selectedBrand = {} as Brand;
  selectedPlan = {} as Plan;
  selectedProgram = {} as Program;
  // se usa en summary Comentados devido a que summary no se esta llamando
  // selectedPlanType = {} as PlanType;
  // selectedInsurance = {} as Insurance;
  selectedDeadLines: DeadLine[] = [];
  selectedCoverages: Coverage[] = [];
  //Lista de datos para los select de quotation
  planTypes!: PlanType[]; //Se usa de assets a financing
  coverages!: Coverage[];
  deadLines: DeadLine[] = [];
  vehicleUses: VehicleUse[] = [];
  insurancePayments: InsurancePayment[] = [];
  annualInsurances: AnnualInsurance[] = [];
  deadLinesCompare!: QuotationCompareDeadLines[];
  coveragesCompare!: QuotationCompareCoverages[];
  //Información para el comparativo
  selectedDeadline!: DeadLine;
  quotationComparatives: QuotationComparative[] = [];
  selectedQuotationComparative!: QuotationComparative;
  quotationFinancialValues!: QuotationFinancialValues;
  selectedQuotationFinancialValue: QuotationEditFinalValues = {} as QuotationEditFinalValues;
  //Formulario de los valores financieros en Quotation
  financialValuesGroup!: FormGroup;
  //Información general
  quotationId: any;
  ticketId!: number;
  comparativeData: any = {};
  summaryVisibility: any;
  //Variables para ejecutar métodos de los componentes hijos (Se usa al cargar)
  @ViewChild(ClientSectionComponent, { static: false }) clientSection!: ClientSectionComponent;
  @ViewChild(AssetSectionComponent, { static: false }) assetSection!: AssetSectionComponent;
  @ViewChild(FinancingSectionComponent, { static: false })
  financingSection!: FinancingSectionComponent;
  @ViewChild(PremisesSectionComponent, { static: false })
  premisesSection!: PremisesSectionComponent;
  @ViewChild(ComparativeComponent, { static: false }) comparativeSection!: ComparativeComponent;

  // Responsivo
  clientSectionColumm = 2;

  constructor(
    private loader: EventEmiterService,
    private router: Router,
  ) {}

  ngOnInit() {
    if (this.initQuotationId != undefined) {
      localStorage.setItem('quotationId', this.initQuotationId.toString());
      localStorage.setItem('isUpdate', '1');
    } else {
      localStorage.removeItem('quotationId');
      localStorage.setItem('isUpdate', '0');
    }
    if (this.initTicketId != undefined) {
      localStorage.setItem('ticketId', this.initTicketId.toString());
    } else {
      localStorage.removeItem('ticketId');
    }

    this.activeToolBar = false;
    this.quotationId = localStorage.getItem('quotationId');
    this.ticketId = Number(localStorage.getItem('ticketId'));
    if (this.quotationId > 0) {
      this.hasQuotation = true;
    } else {
      this.quotationId = 0;
      this.ticketId = 0;
    }
  }

  async ngAfterViewInit(): Promise<void> {
    if (this.hasQuotation) {
      await this.clientSection.loadQuotation();
      if (await this.clientSection.onSubmitCustomer(true)) {
        this.loader.isLoadingPage(true);
        await this.assetSection.loadQuotation();
        if (this.assetSection.onSubmitAsset(true)) {
          await this.financingSection.loadQuotation();
          this.financingSection.onSubmitFinancing(true);
        }
      }
    } else {
      this.assetSection.assetFormGroup.disable();
      this.financingSection.financingFormGroup.disable();
      this.premisesSection.financialValuesGroup.disable();
    }
  }

  goToWF() {
    window.parent.location.href = 'https://123leasedynamic.einteligent.com/#/workflow';
  }

  //todos estos son de los componentes
  sendToComparative() {
    // reinicio del componente comparativo
    this.comparativeData = {
      selectedDeadline: this.selectedDeadline,
      selectedDeadLines: this.selectedDeadLines,
      selectedQuotationComparative: this.selectedQuotationComparative,
      selectedQuotationFinancialValue: this.selectedQuotationFinancialValue,
      quotationComparatives: this.quotationComparatives,
      selectedCoverages: this.selectedCoverages,
    };
    this.activateComparative = true;
  }

  async refreshComparative() {
    // refresco del componente comparativo
    var temp: any = this.selectedDeadline;
    await this.financingSection.loadFinancingDatas();
    setTimeout(() => {
      if (temp.id > 0) this.comparativeSection.selectQuotation(temp.id);
    }, 1000);
  }

  async restartComparative() {
    // reinicio del componente comparativo
    await this.financingSection.loadFinancingDatas(true);
  }

  updateComparative(eventoComparativo: any) {
    // this.activeQuotationPDF = true;
    this.selectedDeadline = eventoComparativo.selectedDeadline;
    this.selectedDeadLines = eventoComparativo.selectedDeadLines;
    this.selectedQuotationComparative = eventoComparativo.selectedQuotationComparative;
    this.selectedQuotationFinancialValue = eventoComparativo.selectedQuotationFinancialValue;
    this.quotationComparatives = eventoComparativo.quotationComparatives;
    this.selectedCoverages = eventoComparativo.selectedCoverages;
    this.comparativeData = eventoComparativo;
    //this.activateComparative = true;
  }

  //viene de regreso del componente hijo clientloadInsurancePayments
  updateCustomer(clientEvent: any) {
    this.customer = clientEvent.customer;
    this.selectedPersonType = clientEvent.selectedPersonType;
    this.quotationId = clientEvent.quotationId;
    this.assetSection.assetFormGroup.enable();
  }

  //viene de regreso del componente hijo asset
  updateAsset(assetEvent: any) {
    this.clientSection.customerFormGroup.get('personType')!.disable();
    this.selectedDestination = assetEvent.selectedDestination;
    this.selectedBrand = assetEvent.selectedBrand;
    this.modelSelected = assetEvent.modelSelected;
    this.planTypes = assetEvent.planTypes;
    this.activateComparative = false;
    this.financingSection.financingFormGroup.enable();
  }

  //viene de regreso del componente hijo financing
  updatefinancing(financingEvent: any) {
    //se usa en summary
    // this.selectedPlanType = financingEvent.selectedPlanType;
    this.selectedProgram = financingEvent.selectedProgram;
    //se usa en summary
    // this.selectedInsurance = financingEvent.selectedInsurance;
    this.selectedDeadLines = financingEvent.selectedDeadLines;
    this.deadLines = financingEvent.deadLines;
    this.selectedCoverages = financingEvent.selectedCoverages;
    this.coverages = financingEvent.coverages;
    this.activeToolBar = true;
    this.activateComparative = true;
    this.premisesSection.financialValuesGroup.enable();
    this.premisesSection.getFinancialValues();
    this.premisesSection.loadVehicleUses();
    this.premisesSection.loadInsurancePayments();
  }

  async GetQuotationPDF(obj: SelectQuotationOutData) {
    this.activeQuotationPDF = obj.activequotationPDF;
    this.selectedDeadline = obj.selectedDeadLine;
    this.premisesSection.getFinancialValues();
  }

  finishQuotation(event: any) {
    localStorage.setItem('selectedTicketId', '' + event);
    localStorage.setItem('selectedAgreementId', '11');
    this.router.navigate(['/workflow']);
  }
}
